import AccountType from '@/constants/AccountType';
import jwtDecode from 'jwt-decode';
import CurrentUserModel from '../models/userInfos/currentUserModel';

export default class CurrentUserService {
  public static userInfo: CurrentUserModel;

  static SetUserInfo(account: string, token: string): void {
    const decodeToken:any = jwtDecode(token);
    this.userInfo = new CurrentUserModel();
    this.userInfo.name = decodeToken.n;
    this.userInfo.account = account;
    this.userInfo.id = decodeToken.ni;
    this.userInfo.accountType = <AccountType>(Number(decodeToken.at));
    this.userInfo.role = decodeToken.r.split(',');
    sessionStorage.userInfo = JSON.stringify(this.userInfo);
    sessionStorage.imToken = token;
  }

  static GetUserInfo(): CurrentUserModel {
    if (this.userInfo) return this.userInfo;
    if (sessionStorage.userInfo) {
      // const t = JSON.parse(sessionStorage.userInfo);
      // this.userInfo = new CurrentUserModel();
      // this.userInfo.name = t.name;
      // this.userInfo.account = t.account;
      // this.userInfo.accountType = t.accountType;
      // this.userInfo.role = t.role;
      // this.userInfo.id = t.id;
      // return this.userInfo;
      this.userInfo = JSON.parse(sessionStorage.userInfo);
      return this.userInfo;
    }
    return new CurrentUserModel();
  }
}
